import { Grid, makeStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import * as PropTypes from 'prop-types'
import React from 'react'
import { darkBlue, defaultC } from '../constants/colors'

const useStyles = makeStyles(theme => ({
	label: {
		fontWeight: 500,
		fontSize: theme.typography.pxToRem(15),
		color: defaultC
	},
	value: {
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(15),
		color: darkBlue
	},

	secondValue: {
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(15),
		color: darkBlue
	}
}))

const FieldInfo = ({
	label,
	value,
	secondVal,
	classNameValue,
	classNameSValue,
	classNameLabel,
	vertical = false,
	styleLabel,
	styleValue,
	styleSValue,
	md = 12,
	xs = 12
}) => {
	const classes = useStyles()
	return (
		<Grid
			item
			container
			xs={xs}
			md={md}
			spacing={1}
			direction={vertical ? 'column' : 'row'}
		>
			<Grid item>
				<Typography
					style={styleLabel}
					className={classNameLabel ? classNameLabel : classes.label}
				>
					{label}
				</Typography>
			</Grid>

			<Grid item>
				<Typography
					style={styleValue}
					className={classNameValue ? classNameValue : classes.value}
				>
					{value}
				</Typography>
			</Grid>
			{secondVal && (
				<Grid item>
					<Typography
						style={styleSValue}
						className={classNameSValue ? classNameSValue : classes.secondValue}
					>
						{secondVal}
					</Typography>
				</Grid>
			)}
		</Grid>
	)
}
export default FieldInfo
FieldInfo.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	variantLabel: PropTypes.string,
	classNameValue: PropTypes.string
}
